<template>
    <div id="planning" class="table-responsive">
        <table class="table table-hover">
            <thead class="thead-azure-dark">
                <tr>
                    <th class="max100">Datum</th>
                    <th class="max100">Aanvang</th>
                    <th class="max100">Duur (uren)</th>
                    <th>Opdracht</th>
                    <th>Professional</th>
                    <th>Status</th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="isLoading">
                <tr>
                    <td colspan="7" class="text-center" >
                        <loader width="3rem"></loader>
                    </td>
                </tr>
            </tbody>
            <tbody v-else-if="planning.length == 0">
                <tr>
                    <td colspan="7" class="text-center pt-5 pb-5" >
                        <h4 class="text-muted">Uw planning is nog leeg...</h4>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr v-for="p in planning" :key="p.id" :class="{ 'table-warning': p.assignmentStatusId == 1}">
                    <td class="nowrap max100">{{new Date(p.date).toLocaleDateString()}}</td>
                    <td :class="['nowrap max100', { 'pt-0 pb-0' : edit }]">
                        <span v-if="!edit">{{new Date(p.startTime).toLocaleTimeString()}}</span>
                        <input v-else type="time" v-model="p.startTime" class="form-control" @change="update(p)" />
                    </td>
                    <td :class="['nowrap max100', { 'pt-0 pb-0' : edit }]">
                        <span v-if="!edit">{{p.hours}}</span>
                        <input v-else type="number" v-model="p.hours" class="form-control" @change="update(p)" />
                    </td>
                    <td class="ellipsis">{{p.title}}</td>
                    <td class="nowrap">
                        {{p.professional}}                            
                        <img src="@/assets/no_security_30.png" class="ml-2" v-if="!p.isSecurity" title="Geen Beveiliger" alt="Geen Beveiliger" height="25" width="25" />
                    </td>
                    <td class="nowrap">{{p.assignmentStatus.description}}</td>
                    <td class="nowrap">
                        <font-awesome-icon icon="trash-alt" v-if="p.assignmentStatusId == 1" class="pointer" @click="cancelUser(p)" />
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="7" class="text-md-right text-left">
                        <button class="btn btn-azure-dark mr-3" v-if="!!assignment" :disabled="planning.length == 0" @click="$emit('send')">Uitnodigen</button>
                        <button class="btn btn-outline-azure-dark" :disabled="planning.length == 0" @click="downloadCSV">Download CSV</button>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import Loader from '@/components/Loader';

export default {
    name: 'planning',
    components: {
        Loader
    },
    props: {
        api: {
            type: Boolean,
            default: true
        },
        assignment: {
            type: Object,
            default: null
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isLoading: true,
            planning: []
        }
    },
    mounted() {
        this.getPlanning();
    },
    methods: {
        update(p) {
            this.$emit('update', p);
        },
        getPlanning() {
            this.isLoading = true;
            if(this.api)
            {
                this.$http.get('api/Planning').then((res) => {
                    this.planning = res.data;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                })
            } else {
                this.isLoading = false;
            }
        },
        cancelUser(user) {
            if(this.api) 
            {
                this.$http.post('api/Planning/Cancel/' + user.id).then((res) => {
                    this.planning.splice(this.planning.indexOf(user), 1);
                    this.$emit('remove', user);
                }).catch(() => {
                })
            } else {
                this.planning.splice(this.planning.indexOf(user), 1);
                this.$emit('remove', user);
            }
        },
        downloadCSV() {
            const properties = ["id", "date", "startTime", "hours", "title", "professional", "assignmentStatusId"]
            let csvContent = "data:text/csv;charset=utf-8," + properties.join(",") + "\n";
            
            csvContent += this.planning.map((p) => {
                let map = [];
                for(let prop in p)
                {
                    if(properties.indexOf(prop) >= 0)
                        map.push(p[prop]);
                }
                return encodeURI(map.join(","))
            }).join('\n');

            let link = document.createElement("a");
            link.setAttribute("href", csvContent);
            link.setAttribute("download", "planning.csv");
            document.body.appendChild(link); // Required for FF
            console.log(csvContent);
            link.click();
            document.body.removeChild(link);
        }
    },
    computed: {
    },
    watch: {
        assignment: {
            handler(to)
            {
                this.isLoading = true;
                this.planning = [];
                this.assignment.dates.forEach(d => {
                    d.assignmentUsers.forEach(u => {
                        this.planning.push({
                            id: -(this.planning.length + 1),
                            date: d.date,
                            startTime: u.startTime,
                            hours: u.hours,
                            assignment: this.assignment.id,
                            title: 'Nieuwe Opdracht',
                            applicationUserId: u.applicationUserId,
                            professional: u.applicationUser.firstName,
                            assignmentStatusId: u.assignmentStatusId,
                            assignmentStatus: {
                                description: 'Open'
                            },
                            isSecurity: true
                        });
                    })
                });
                this.isLoading = false;
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
.pointer:hover {
    color: darkred;
}
.max100 {
    max-width: 150px;
    min-width: 150px;
}
</style>